import {IHttpPromise, IHttpService} from "angular";
import {HistoricalPriceRange, HistoricalPriceResponse} from "./HistoricalPriceModels";

export class HistoricalPriceService {

    public static id = "historicalPriceService";

    private rangeCache = new Map<string, IHttpPromise<HistoricalPriceRange>>();

    /** @ngInject */
    public constructor(private $http: IHttpService) {

    }

    public async prices(underlying: string, asAt: string): Promise<HistoricalPriceResponse> {
        const url = `/tradefloor/api/historical/prices/${asAt}/${underlying}`;
        const response = await this.$http.get<HistoricalPriceResponse>(url);
        return response.data!;
    }

    public async priceRange(underlying: string): Promise<HistoricalPriceRange> {
        if (!this.rangeCache.has(underlying)) {
            const url = `/tradefloor/api/historical/price-range/${underlying}`;
            const request = this.$http.get<HistoricalPriceRange>(url);
            this.rangeCache.set(underlying, request);
        }
        const response = await this.rangeCache.get(underlying)!;
        return response.data!;
    }
}
